import { FolderPlus } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

import { CreatePlaylistForm } from "./create-playlist-form";

type CreatePlaylistModalProps = {
  isEmpty: boolean;
  variant?: "outline" | "default";
};

export function CreatePlaylistModal({
  isEmpty,
  variant = "default",
}: CreatePlaylistModalProps) {
  const [isCreatePlaylistModalOpen, setIsCreatePlaylistModalOpen] =
    useState(false);

  return (
    <Dialog
      open={isCreatePlaylistModalOpen}
      onOpenChange={setIsCreatePlaylistModalOpen}
    >
      <DialogTrigger asChild>
        <Button
          type="button"
          variant={variant}
          className={cn("flex", isEmpty ? "self-center" : "self-start")}
        >
          <FolderPlus className="mr-2 size-4" />
          New playlist
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle>New playlist</DialogTitle>
        </DialogHeader>
        <CreatePlaylistForm
          onClose={() => setIsCreatePlaylistModalOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
